import { defineMessages } from 'react-intl';

const messages = defineMessages({
  privacyPolicyAccepted: {
    id: 'hooks.admin.organizations.privacyPolicyAccepted',
    defaultMessage: 'Privacy policy accepted successfully!',
  },
  privacyPolicyCreated: {
    id: 'hooks.admin.organizations.privacyPolicyCreated',
    defaultMessage: 'Privacy policy created successfully!',
  },
  privacyPolicyDeleted: {
    id: 'hooks.admin.organizations.privacyPolicyDeleted',
    defaultMessage: 'Privacy policy deleted successfully!',
  },
});

export default messages;
